import { Injectable } from '@angular/core';

export function isHeicImage(...values: (string | null | undefined)[]): boolean {
  return values.some(
    value =>
      typeof value === 'string' &&
      /(?:^|[./])hei[cf]$/i.test(value.split(/[?#;]/)[0])
  );
}

@Injectable({ providedIn: 'root' })
export class HeicPreviewService {
  async createPreview(source: string, signal: AbortSignal): Promise<Blob> {
    // Use the existing signed attachment URL; do not send API credentials to storage.
    const response = await fetch(source, { signal, credentials: 'omit' });
    if (!response.ok) {
      throw new Error('Unable to load attachment preview');
    }
    const original = await response.blob();
    signal.throwIfAborted();

    // The decoder is only loaded when a HEIC attachment is opened. The CSP build
    // does not require unsafe-eval or a third-party conversion service.
    const { heicTo } = await import('heic-to/csp');
    signal.throwIfAborted();
    const preview = await heicTo({
      blob: original,
      type: 'image/jpeg',
      quality: 0.85
    });
    signal.throwIfAborted();
    return preview;
  }
}
